module.exports = __webpack_public_path__ + "img/client20.4f0a3619.svg";